import { render, staticRenderFns } from "./PurchaseOrdersFilters.vue?vue&type=template&id=542020e0&scoped=true&"
import script from "./PurchaseOrdersFilters.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersFilters.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrdersFilters.vue?vue&type=style&index=0&id=542020e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542020e0",
  null
  
)

export default component.exports